import React, { Component } from 'react';
import Modal from 'react-bootstrap4-modal';
import arrowBackIcon from '../../../../static/svg/back.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { TimePicker, Tooltip, DatePicker, ConfigProvider } from 'antd';
import closeIcon from '../../../../static/svg/ic-close-circle.svg';
import { connect } from 'react-redux';
import moment from 'moment';
import { verifySlotSession } from '../../../../redux/actions/mvp/session.action';
import debounce from 'lodash/debounce';
import warning from '../../../../static/images/mvp/warning.png';
import { toast } from 'react-toastify';
import {
  changeDateLocaleToUTC, changeDateUTCToLocale,
  convertToGMTLocal,
  convertToUTC,
  dataTimesDefault,
  daysOfWeek,
  getTimeRangeUtc, mapDateTimeToUtc,
  slotDefault,
} from './helper';
import lodash from 'lodash'
import { I18n, getAntdLocale } from '../../../../helpers/i18n';

const { RangePicker } = DatePicker;
const getKeyToMessage = () => ({
  isValidOverlap: I18n.t('session_date_time_error'),
  isValidStartBeforeEnd: I18n.t('session_st_before_et')
});

class ConfigTimeSlots extends Component {
  constructor(props) {
    super(props);
    let dataTime = dataTimesDefault()
    if (props.dataTime.length) {
      dataTime = lodash.cloneDeep(props.dataTime);
    } else if (props.oldDataTime.length) {
      dataTime = lodash.cloneDeep(props.oldDataTime);
    }
    const weekLabels = daysOfWeek();
    dataTime = dataTime.map((item) => ({
      ...item,
      label: weekLabels[item.startDate] || item.label,
    }));
    this.state = {
      topicId: this.props.topicId,
      dataTime: [...dataTime],
    };
    this.timePickerRefs = {};
    this.rangePickerRef = null;

    this.debouncedApiCall = debounce(this.apiVerifySlotSession.bind(this), 500);
    this.debouncedApiTypeSelect = debounce(this.buddyTimeslotTypeSelect.bind(this), 500);
  }

  getTimeSlotTypeOptions = () => ([
    {
      label: I18n.t('time_slot_type_expiration'),
      value: 'unlimit',
    },
    {
      label: I18n.t('time_slot_type_range'),
      value: 'limit',
    },
  ]);


  componentWillUnmount() {
    this.debouncedApiCall.cancel();
  }

  async buddyTimeslotTypeSelect(value) {
    const {timeSlotTypeChoose} = this.props
    await this.props.buddyTimeslotTypeSelect(value);
    if (value !== timeSlotTypeChoose) {
      await this.verifyAllSlotSession()
    }
  }

  verifyAllSlotSession = async (needFocus = false) => {
    let isValid = true;
    const { dataTime } = this.state;

    const timeSlots = mapDateTimeToUtc(dataTime)
    if (!timeSlots.length) {
      return false
    }

    const needValid = timeSlots.map((item) => {
      const params = {
        startDate: item.startDate,
        timeSlotStart: null,
        timeSlotEnd: null,
        data: item.data.map(slot => ({ start: slot.start, end: slot.end })),
      };
      if (this.props.timeSlotTypeChoose === 'limit') {
        const mapTimeZoneResult = getTimeRangeUtc(this.props.timeSlotStart, this.props.timeSlotEnd)
        params.timeSlotStart = mapTimeZoneResult.timeSlotStart;
        params.timeSlotEnd = mapTimeZoneResult.timeSlotEnd
      }
      return params
    });

    await Promise.all(needValid.map(params => this.apiVerifySlotSession(params)));

    this.state.dataTime.forEach((item, timeIndex) => {
      if (!item.apply || !item.data?.length || !isValid) {
        return;
      }
      item.data.forEach((slot, slotIndex) => {
        if (!isValid) {
          return;
        }
        if (slot.messages || slot.overlapWiths?.length) {
          isValid = false;
        }
        if (needFocus && !isValid) {
          this.timePickerRefs[timeIndex][slotIndex]?.focus();
        }
      });
    });

    return isValid
  }

  saveTimeSlotConfig = async () => {
    const { timeSlotTypeChoose } = this.props;
    if (timeSlotTypeChoose === 'limit' && this.validateRangeTime()) {
      this.rangePickerRef?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'start',
      });
      return false;
    }

    if (!await this.verifyAllSlotSession(true)) {
      toast.error(`${I18n.t('session_slot_setup_er')} ${I18n.t('session_can_edit_check_again')}`, {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        closeButton: false,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        className: 'toast-error-container toast-error-container-after',
        theme: 'colored',
      });
      return false;
    }

    this.props.prepareTimeSlotConfig(this.state.dataTime);
    this.props.toggleConfigTimeSlot();
  };

  cancelConfig = () => {
    this.props.prepareTimeSlotConfig([]);
    this.props.buddyTimeslotTypeSelect('unlimit');
    this.props.timeSlotTypeDateChange(null, null);
    this.props.toggleConfigTimeSlot();
  };

  handleRemoveData = (dataTimeIndex, dayIndex) => {
    this.setState(prevState => {
      const updatedDataTime = [...prevState.dataTime];
      const dayData = updatedDataTime[dataTimeIndex].data;

      const updatedDayData = dayData.filter((_, index) => index !== dayIndex);
      updatedDataTime[dataTimeIndex].data = updatedDayData;

      if (updatedDayData.length === 0) {
        updatedDataTime[dataTimeIndex].apply = false;
      }

      return { dataTime: updatedDataTime };
    }, () => {
      const updatedDataTime = [...this.state.dataTime];
      const dayData = updatedDataTime[dataTimeIndex].data;
      if (dayData.filter((slot) => (slot.messages || slot.overlapWiths?.length)).length) {
        this.handleBlur(dataTimeIndex);
      }
    });

  };

  applyDayInWeek(index) {
    this.setState(prevState => {
      const updatedDataTime = [...prevState.dataTime];
      updatedDataTime[index].apply = !updatedDataTime[index].apply;
      if (updatedDataTime[index].apply && !updatedDataTime[index].data.length) {
        updatedDataTime[index].data = [slotDefault];
      }
      if (!updatedDataTime[index].apply) {
        updatedDataTime[index].data = updatedDataTime[index].data.map(item => ({ start: item.start, end: item.end }));
      }
      return { dataTime: updatedDataTime };
    }, () => {
      if (this.state.dataTime[index].apply) {
        this.handleBlur(index);
      }
    });
  }

  addDay = (dataTimeIndex) => {
    this.setState(prevState => {
      const updatedDataTime = [...prevState.dataTime];
      updatedDataTime[dataTimeIndex].data.push(slotDefault);
      return { dataTime: updatedDataTime };
    }, () => {
      const newSlotIndex = this.state.dataTime[dataTimeIndex].data.length - 1;
      if (this.timePickerRefs[dataTimeIndex] && this.timePickerRefs[dataTimeIndex][newSlotIndex]) {
        this.timePickerRefs[dataTimeIndex][newSlotIndex].focus();
      }
    });
  };

  handleBlur = async (dayIndex) => {
    if (!this.state.dataTime[dayIndex].apply) {
      return false;
    }
    let { startDate, data } = this.state.dataTime[dayIndex]
    if (data.length === 1) {
      const dateInWeek = changeDateLocaleToUTC(startDate, data[0].start)
      startDate = dateInWeek ? dateInWeek : startDate
      const params = {
        startDate: startDate,
        data: [{start: convertToUTC(data[0].start), end: convertToUTC(data[0].end)}],
        timeSlotStart: null,
        timeSlotEnd: null,
      };

      if (this.props.timeSlotTypeChoose === 'limit') {
        const mapTimeZoneResult = getTimeRangeUtc(this.props.timeSlotStart, this.props.timeSlotEnd)
        params.timeSlotStart = mapTimeZoneResult.timeSlotStart;
        params.timeSlotEnd = mapTimeZoneResult.timeSlotEnd
      }
      this.debouncedApiCall(params);
    } else {
      const dateChange = {}
      data.forEach((slots) => {
        let newStartDate = startDate
        const dateInWeek = changeDateLocaleToUTC(startDate, slots.start);
        if (dateInWeek) {
          newStartDate = dateInWeek
        }
        const newSlots = {start: convertToUTC(slots.start), end: convertToUTC(slots.end)}
        if (dateChange[newStartDate]) {
          dateChange[newStartDate].push(newSlots)
        } else {
          dateChange[newStartDate] = [newSlots]
        }
      })
      const arrParams = []
      Object.keys(dateChange).forEach((dateInWeek) => {
        const params = {
          startDate: dateInWeek,
          data: dateChange[dateInWeek],
          timeSlotStart: null,
          timeSlotEnd: null,
        };

        if (this.props.timeSlotTypeChoose === 'limit') {
          const mapTimeZoneResult = getTimeRangeUtc(this.props.timeSlotStart, this.props.timeSlotEnd)
          params.timeSlotStart = mapTimeZoneResult.timeSlotStart;
          params.timeSlotEnd = mapTimeZoneResult.timeSlotEnd
        }
        arrParams.push(params)
      })
      await Promise.all(arrParams.map(params => this.apiVerifySlotSession(params)));
    }
  };

  async apiVerifySlotSession(params) {
    params = {
      startDate: params.startDate,
      timeSlotStart: params.timeSlotStart,
      timeSlotEnd: params.timeSlotEnd,
      dataTime: params.data.map(slot => ({ start: slot.start, end: slot.end, })),
      topicId: this.state.topicId || ''
    };
    const valid = await this.props.verifySlotSession(params);
    if (valid.isValid) {
      this.setState(prevState => {
        const updatedDataTime = prevState.dataTime.map(day => {
          if (day.startDate?.toLowerCase() === params.startDate?.toLowerCase()) {
            return {
            ...day,
              data: day.data.map(slot => ({ start: slot.start, end: slot.end })),
            };
          }
          return day
        });
        return { dataTime: updatedDataTime};
      });
      return true;
    }

    const validDataTime = valid.dataTime;
    let mapValid = {}
    validDataTime.forEach(time => {
      const dateInWeek = changeDateUTCToLocale(params.startDate, time.start)
      let startDate = dateInWeek ? dateInWeek : params.startDate
      if (mapValid[startDate]) {
        mapValid[startDate].push(time)
      } else {
        mapValid[startDate] = [time]
      }
    })
    this.setState(prevState => {
      const updatedDataTime = prevState.dataTime.map(day => {
        if (!day.apply){
          return day
        }
        if (!mapValid[day.startDate]){
          return day
        }

        return {
          ...day,
          data: day.data.map(slot => {
            const newSlot = { ...slot, messages: '', overlapWiths: [] };
            const validSlot = mapValid[day.startDate].find(newSlot => convertToGMTLocal(newSlot.start) === slot.start);

            if (!validSlot) {
              return newSlot;
            }

            const keyToMessage = getKeyToMessage();
            if (validSlot.isValidStartBeforeEnd === false) {
              newSlot.messages = keyToMessage['isValidStartBeforeEnd'];
            }

            if (validSlot.isValidOverlap === false) {
              newSlot.messages = keyToMessage['isValidOverlap'];
            }

            if (validSlot.overlapWiths?.length) {
              validSlot.overlapWiths.forEach(over => {
                let topicTime = ''
                if (over.startTimeTopic) {
                  topicTime = ` ${I18n.t('session_time_range', {
                    date: over.startTimeTopic && over.endTimeTopic ? `${moment(over.startTimeTopic).format('DD/MM/YY')} - ${moment(over.endTimeTopic).format('DD/MM/YY')}` : moment(over.startTimeTopic).format('DD/MM/YY'),
                  })}`
                }
                let {startDate} = over
                const dateInWeek = changeDateUTCToLocale(startDate, over.startTimeSlot)
                startDate = dateInWeek ? dateInWeek : startDate
                newSlot.overlapWiths.push({
                  timeSlot: `${daysOfWeek()[startDate.toLowerCase()]} / ${convertToGMTLocal(over.startTimeSlot)} - ${convertToGMTLocal(over.endTimeSlot)}${topicTime}`,
                  session: over.sessionName,
                });
              });
            }
            return newSlot;
          }),
        };
      });

      return { dataTime: updatedDataTime };
    });
  }

  handleChangeTime = (dayIndex, timeIndex, time) => {
    if (time) {
      const newStart = time.format('HH:mm');
      const newEnd = time.add(45, 'minutes').format('HH:mm');
      this.setState(prevState => {
        const updatedDataTime = [...prevState.dataTime];
        updatedDataTime[dayIndex].data[timeIndex] = {
          start: newStart,
          end: newEnd,
        };
        return { dataTime: updatedDataTime };
      }, () => {
        this.handleBlur(dayIndex)
      });
    }
  };
  handleTimeSlotTypeDateChange = async (dates) => {
    await this.props.timeSlotTypeDateChange(dates[0], dates[1]);
    await this.verifyAllSlotSession()
  };
  validateRangeTime = () => {
    const { timeSlotTypeChoose, timeSlotStart, timeSlotEnd } = this.props;
    if (timeSlotTypeChoose !== 'limit') {
      return '';
    }
    const toDay = moment().startOf('day');
    const timeStart = timeSlotStart?.startOf('day');
    if (timeStart?.isBefore(toDay)) {
      return I18n.t('session_st_valid');
    }
    if (!timeSlotStart && !timeSlotEnd) {
      return I18n.t('text_field_required_error');
    }
    return '';
  };

  render() {
    const { timeSlotTypeChoose, timeSlotConfig, timeSlotStart, timeSlotEnd } = this.props;
    const rangeTimeNull = this.validateRangeTime();
    const { dataTime } = this.state;
    const timeSlotType = this.getTimeSlotTypeOptions();
    return (
      <Modal id="config-modal"
             size="lg"
             visible={timeSlotConfig}
             dialogClassName="modal-dialog-centered">
        <div className="modal-body">
          <div className="d-flex align-items-center">
            <img
              className="cursor-pointer mr-3"
              src={arrowBackIcon}
              alt="Arrow Back"
              onClick={() => this.cancelConfig()}
            />
            <span className="modal-title">{I18n.t('config_session')}</span>
          </div>
          <div className="section"></div>
          <div className="d-flex justify-content-center flex-column">
            <span>{I18n.t('config_session_step_1')} <small style={{ color: 'red' }}>*</small>
            </span>
            <label>{I18n.t('config_session_step_1_hint')}</label>
            {timeSlotType.map((option) => (
              <div
                className="d-flex align-items-center mb-2">
                <label className="radio-custom cursor-pointer" onClick={
                  (event) => {
                    event.preventDefault();
                    this.debouncedApiTypeSelect(option.value)
                  }
                }>
                  <input type="checkbox" checked={timeSlotTypeChoose === option.value} />
                  <div className="outer-circle">
                    <div className="inner-circle"></div>
                  </div>
                </label>
                <span className="cursor-pointer" onClick={
                  (event) => {
                    event.preventDefault();
                    this.debouncedApiTypeSelect(option.value)
                  }
                }>{option.label}</span>
                {timeSlotTypeChoose === 'limit' && option.value === 'limit' && (
                  <div ref={(ref) => this.rangePickerRef = ref} className="d-flex flex-column justify-content-center">
                    <ConfigProvider locale={getAntdLocale()}>
                    <RangePicker
                      locale={getAntdLocale()}
                      size="small"
                      className={`tlst-picker ml-2 ${rangeTimeNull ? 'error' : ''}`}
                      onChange={this.handleTimeSlotTypeDateChange}
                      value={[timeSlotStart, timeSlotEnd]}
                      format={'DD/MM/YYYY'}
                      placeholder={null}
                      suffixIcon={null}
                      separator=" - "
                      allowClear={false}
                    />
                    </ConfigProvider>
                    {rangeTimeNull && (
                      <span className="error-message mt-1 ml-2">
                      <img src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} />
                        {rangeTimeNull}
                    </span>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
          <div className="section"></div>
          <div className="d-flex justify-content-center flex-column">
                      <span>{I18n.t('config_session_step_2')} <small
                        style={{ color: 'red' }}>*</small></span>
            <label className="mb-4">
              {I18n.t('config_session_step_2_hint')}
            </label>
            <ConfigProvider locale={getAntdLocale()}>
            <div className="tl-section">
              {dataTime.map((day, dataTimeIndex) => (
                <div className="tls-item">
                  <div onClick={() => this.applyDayInWeek(dataTimeIndex)}
                       style={{ height: '56px' }} className="d-flex align-items-center">
                    {day.apply ? (
                        <FontAwesomeIcon
                          className="cursor-pointer"
                          icon={faCheckCircle} style={{ fontSize: '24px', color: '#61E6BD' }} />
                      )
                      :
                      (<div className="circle"></div>)
                    }
                  </div>
                  <span style={{ minWidth: '103px', height: '56px' }}
                        className="d-flex align-items-center">{day.label}</span>
                  {day.data.length ? (
                    <div className="d-flex flex-column justify-content-center w-75" style={{ gap: '8px' }}>
                      {day.data.map((item, dayIndex) => (
                        <div className="d-flex flex-column justify-content-center">
                          <div className="d-flex align-items-center" style={{ gap: '12px' }}>
                            <TimePicker
                              placeholder={null}
                              className={`tlsi-picker ${item.messages || item.overlapWiths?.length ? 'error' : ''}`}
                              suffixIcon={null}
                              allowClear={false}
                              onChange={(time) => this.handleChangeTime(dataTimeIndex, dayIndex, time)}
                              value={moment(item.start, 'HH:mm')} format={'HH:mm'}
                              ref={(ref) => {
                                if (!this.timePickerRefs[dataTimeIndex]) {
                                  this.timePickerRefs[dataTimeIndex] = [];
                                }
                                this.timePickerRefs[dataTimeIndex][dayIndex] = ref;
                              }}
                            />
                            <span style={{ fontSize: '16px' }}>{I18n.t('to')}</span>
                            <Tooltip title={I18n.t('config_session_tooltip_time')} placement="top">
                              <TimePicker
                                className={`tlsi-picker ${item.messages || item.overlapWiths?.length ? 'error' : ''}`}
                                placeholder={null}
                                disabled={true}
                                suffixIcon={null}
                                allowClear={false}
                                value={moment(item.end, 'HH:mm')} format={'HH:mm'}
                              />
                            </Tooltip>
                            <img
                              className="cursor-pointer"
                              src={closeIcon}
                              alt="Arrow close"
                              style={{ width: '24px', height: '24px' }}
                              onClick={() => this.handleRemoveData(dataTimeIndex, dayIndex)}
                            />
                          </div>
                          {item.messages && (
                            <span className="error-message mt-1">
                              <img src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} />
                              {item.messages}
                            </span>
                          )}
                          {item.overlapWiths?.length ? (
                            <div className="d-flex justify-content-center flex-column">
                              <span className="error-message mt-1">
                                  <img src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} />
                                {I18n.t('session_date_time_error')}. {I18n.t('details')}
                              </span>
                              <div className="error-overlap mt-1">
                                {I18n.t('config_session_time_multi_hint')}
                                <ul className="mb-0 pl-3">
                                  {item.overlapWiths?.map(over => (
                                    <li>{I18n.t('config_session_overlap_hint', {
                                      x: over.timeSlot,
                                      y: over.session
                                    })}</li>
                                  ))}
                                </ul>
                              </div>
                            </div>
                          ) : ''}
                        </div>
                      ))}
                      <div>
                        <a href="javascript:void(0)" onClick={() => this.addDay(dataTimeIndex)}>{I18n.t('session_add_more')}</a>
                      </div>
                    </div>
                  ) : (
                    <label className="d-flex align-items-center mb-0" style={{ fontSize: '20px', height: '56px' }}>{I18n.t('session_empty_in_day')}</label>
                  )}
                </div>
              ))}
            </div>
            </ConfigProvider>            <div className="section"></div>
            <div className="d-flex align-items-center justify-content-end">
              <button
                onClick={() => this.cancelConfig()}
                type="button"
                className="btn-time-slot cursor-pointer">
                {I18n.t('cancel')}
              </button>
              <button
                onClick={() => this.saveTimeSlotConfig()}
                type="button"
                style={{ color: '#000000', background: '#61E6BD' }}
                className="btn-time-slot ml-4 cursor-pointer">
                {I18n.t('save')}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapDispatchToProps = {
  verifySlotSession,
};

export default connect(null, mapDispatchToProps)(ConfigTimeSlots);
